import React, { Component } from 'react'
import { Table, Badge } from 'reactstrap'
import Radium from 'radium'

import unchecked from '../images/unchecked.png'
import checked from '../images/checked.png'
import PillTip from './PillTip'

class ResultsList extends Component {

  state = {
    colors: [ "primary", "success", "danger", "warning", "info" ]
  }

  generateDivList = () => {
    if (!(this.props.results.elections === undefined)) {
      const List = this.props.results.elections.map((election, index) => {
        return (
          <>
          <Table striped key={index}>
            <thead>
              <tr>
                <th style={divTitleStyle} colSpan="3">
                  {
                    (election.division_department.length > 0)?
                    (election.heading + ' Division ' + election.division_department)
                    :
                    (election.heading)
                  }
                </th>
                <th style={divTitleStyle} colSpan="1">Elected</th>
              </tr>
            </thead>
            <tbody style={tableBodyStyle}>
              {this.generateCanList(index)}
              {(election.result_notes.length > 0) && (
                <td colSpan="4">
                  <div style={{textAlign: 'left', background: '#ffffff'}} >{election.result_notes}</div>
                </td>
              )}
            </tbody>
          </Table>
          </>
        )
      })
      return List
    }
    return null
  }

  generateCanList = (index) => {
    if (!(this.props.results.elections[index] === undefined)) {
      const array = this.props.results.elections[index].candidates.sort(this.compare)
      const List = array.map((candidate, index) => {
        const tableRowStyle = {
          background: candidate.is_winner? '#d7c3e8' : '',
          fontFamily: candidate.is_winner? 'AvenirBlack' : 'Avenir',
        }
        const percentage = Math.round(candidate.candidate_votes / this.props.results.total_votes * 100)
        return (
          <tr style={tableRowStyle} key={index}>
            <td style={tableDataStyle}>{candidate.candidate_name}{' '}{this.leavePill(candidate.leave)}</td>
            <td style={tableDataStyle}>{candidate.candidate_votes}</td>
            <td style={tableDataStyle}>{percentage}{'%'}</td>
            <td style={iconStyle}>{this.checkOrUnchecked(candidate.is_winner)}</td>
          </tr>
        )
      })
      return List
    }
    return null
  }

  compare = (a, b) => {
    if (a.candidate_votes > b.candidate_votes) {
      return -1
    }
    if (a.candidate_votes < b.candidate_votes) {
      return 1
    }
    return 0
  }

  checkOrUnchecked = (is_winner) => {
    if(is_winner) {
      return (
        <img src={checked} alt="selected" width="auto" height="32px"/>
      )
    } else {
      return (
        <img src={unchecked} alt="unselected" width="auto" height="32px"/>
      )
    }
  }

  leavePill = (index) => {
    if(!(this.props.leave === undefined)) {
      if(parseInt(index) > 0) {
        return (
          <>
            <Badge color={this.state.colors[index - 1]} pill id={'leave' + index}>{index}</Badge>
            <PillTip
              target={'leave' + index}
              message={this.props.leave[index].leave}
            />
          </>
        )
      }
      return null
    }
    return null
  }

  componentDidMount () {
    window.scrollTo(0,0)
  }

  render () {
    return (
      <div style={boxStyle}>
        <div>
          <h2 style={titleStyle}>{this.props.results.election_name}</h2>
          <p style={textStyle}><span style={{fontFamily: 'AvenirBlack'}}>Election Rules: </span>{this.props.results.election_rules}</p>
          <div>
            <h3 style={subtitleStyle}>{'Total Votes: '}{this.props.results.total_votes}</h3>
          </div>
        </div>
        {this.generateDivList()}
      </div>
    )
  }
}

const tableDataStyle = {
  padding: '10px 0px 0px 8px',
  textAlign: 'left',
}

const textStyle = {
  fontFamily: 'Avenir',
  background: '#ffffff',
  padding: '8px 8px',
  marginBottom: '0px',
}

const boxStyle = {
  width: 'auto',
  height: 'auto',
  display: 'flex',
  flexDirection: 'column',
  border: '2px solid #000000',
  borderRadius: '8px',
  boxShadow: '0px 20px 40px rgba(0, 0, 0, 0.15)',
  background: '#333333',
  '@media (max-width: 420px)': {
    marginTop: '0px'
  },
  '@media (min-width: 421px)': {
    marginTop: '2rem'
  },
  marginBottom: '4rem',
}

const titleStyle = {
  color: '#fff',
  background: '#602d89',
  padding: '16px 5px 8px 8px',
  marginBottom: '0px',
  fontFamily: 'Avenir',
  lineHeight: '1.4',
  '@media (max-width: 420px)': {
    fontSize: '20px'
  },
  '@media (min-width: 421px)': {
    fontSize: '24px',
  },
}

const subtitleStyle = {
  color: '#fff',
  padding: '8px 8px 5px 8px',
  marginBottom: '0px',
  fontFamily: 'Avenir',
  lineHeight: '1.4',
  '@media (max-width: 420px)': {
    fontSize: '18px'
  },
  '@media (min-width: 421px)': {
    fontSize: '20px',
  },
}

const divTitleStyle = {
  color: '#fff',
  background: '#602d89',
  padding: '8px 8px 5px 8px',
  marginBottom: '0px',
  textAlign: 'center',
  fontFamily: 'Avenir',
  lineHeight: '1.4',
  '@media (max-width: 420px)': {
    fontSize: '18px'
  },
  '@media (min-width: 421px)': {
    fontSize: '20px',
  },
}

const tableBodyStyle = {
  background: '#ffffff',
}

const iconStyle = {
  padding: '4px 8px 4px 0px',
  textAlign: 'center',
}

export default Radium(ResultsList)
